
  export default {
    name: 'PanelRectangle',
    props: {
      baserecstyle: String,
      recstyle: String
    }
  }
